<template>
  <dl class="description-list">
    <template v-for="(item, index) in list">
      <dt
        :key="`${index}-title`"
        :qaid="item.qaid ? `${item.qaid}-title` : null"
        :class="['description-list__title', item.titleClass]"
        v-html="item.title"
      />
      <dd
        :key="`${index}-description`"
        :qaid="item.qaid ? `${item.qaid}-description` : null"
        :class="['description-list__description', item.descriptionClass]"
        v-html="item.description"
      />
    </template>
  </dl>
</template>

<script>
export default {
  name: 'DescriptionList',
  props: {
    /**
     * An array of objects for each item in the list. Each item must contain a title & description, and can optionally contain a QAID. Titles must be unique. You can optionally pass classes to an item with titleClass or descriptionClass.
     */
    list: {
      type: Array,
      validator: (list) => list.every((item) => Boolean(item.title) && Boolean(item.description)),
      required: true,
    },
  },
};
</script>

<style scoped lang="scss">
.description-list {
  @apply grid;
  @apply grid-cols-2;
  @apply gap-x-8;
  @apply text-base;
  @apply text-gray-100;

  &__title {
    @apply mb-2;
    @apply font-medium;
  }

  &__description {
    @apply mb-2;
  }
}
</style>
